import { render, staticRenderFns } from "./ReputationTab.vue?vue&type=template&id=52d4a8af&scoped=true"
import script from "./ReputationTab.vue?vue&type=script&lang=js"
export * from "./ReputationTab.vue?vue&type=script&lang=js"
import style0 from "./ReputationTab.vue?vue&type=style&index=0&id=52d4a8af&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d4a8af",
  null
  
)

export default component.exports